$(() => {
  $(document).on('click', '[data-burger]', e => {
    e.preventDefault();
    $('body').toggleClass('app-burger-active');
  });
});
